import { Component, OnInit } from '@angular/core';
import { ReportService } from '../_services/report.service';
import {saveAs as importedSaveAs} from 'file-saver';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  @BlockUI('changelog') blockUIChangelog: NgBlockUI;
  filteredhammeddeler:any[]=[];
  constructor(private propertyService:ReportService) { }

  ngOnInit() {
    this.getProperties();
  }


  getProperties(){
    this.propertyService.getHammaddeler().subscribe((data:any)=>{
      this.filteredhammeddeler=data;
      console.log(data);
    });
  }


  download(id){
    this.blockUIChangelog.start('Loading..');
    this.propertyService.download(id).subscribe(blob=>{
      importedSaveAs(blob, 'rapor.docx');
      this.blockUIChangelog.stop();
    }, err=>{
      this.blockUIChangelog.stop();
    });
  }


  copy(id){
       this.blockUIChangelog.start('Loading..');
    this.propertyService.copy(id).subscribe(res=>{
      this.getProperties();
      this.blockUIChangelog.stop();
    }, err=>{
      this.blockUIChangelog.stop();
    });
  }


  delete(id){
       this.blockUIChangelog.start('Loading..');
    this.propertyService.deleteHammadde(id).subscribe(res=>{
      this.getProperties();
      this.blockUIChangelog.stop();
    }, err=>{
      this.blockUIChangelog.stop();
    });
  }
}

